import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import LoaderPrecios from '../LoaderPrecios/LoaderPrecios';

export default function TarjetaPolitica() {



    return (
        <TarjetaPoliticas>

            <div className='items'>
            <div>
                <h2>Política de Privacidad — Doc Online Argentina</h2>
                <p>En Doc Online Argentina (en adelante, “Doc Online”) respetamos y protegemos la privacidad de nuestros usuarios, pacientes y visitantes. Esta Política de Privacidad explica cómo recopilamos, utilizamos, almacenamos y protegemos la información personal que nos brindás al usar nuestros servicios.</p>

                <h3>1. Información que recopilamos</h3>
                <ul>
                    <li><strong>Datos de identificación personal:</strong> nombre, apellido, DNI, fecha de nacimiento.</li>
                    <li><strong>Datos de contacto:</strong> correo electrónico, número de teléfono, dirección.</li>
                    <li><strong>Información médica:</strong> historia clínica, antecedentes, resultados de estudios necesarios para la prestación del servicio.</li>
                    <li><strong>Información de uso:</strong> cookies, dirección IP, tipo de dispositivo y datos de interacción con el sitio o la app.</li>
                </ul>

                <h3>2. Finalidad del tratamiento de datos</h3>
                <ul>
                    <li>Brindar atención médica y seguimiento de pacientes.</li>
                    <li>Gestionar turnos, consultas y trámites asociados a programas de salud (ej.: Reprocann).</li>
                    <li>Enviar recordatorios, notificaciones y actualizaciones relacionadas con el servicio.</li>
                    <li>Cumplir con obligaciones legales y regulatorias aplicables.</li>
                </ul>

                <h3>3. Compartición de datos</h3>
                <p>No compartimos tu información personal con terceros sin tu consentimiento, salvo:</p>
                <ul>
                    <li>Con profesionales de la salud vinculados a tu atención, cuando sea estrictamente necesario.</li>
                    <li>Cuando sea exigido por ley o por autoridades competentes.</li>
                </ul>

                <h3>4. Seguridad de la información</h3>
                <p>Adoptamos medidas técnicas y organizativas adecuadas para proteger los datos personales frente a accesos no autorizados, pérdidas o alteraciones.</p>

                <h3>5. Derechos del usuario</h3>
                <p>Como titular de los datos tenés derecho a:</p>
                <ul>
                    <li>Acceder a tu información.</li>
                    <li>Solicitar rectificación, actualización o supresión.</li>
                    <li>Revocar tu consentimiento para el tratamiento de datos.</li>
                </ul>
                <p>Podés ejercer estos derechos enviando un correo a: <strong>[tu email de soporte]</strong>.</p>

                <h3>6. Conservación de los datos</h3>
                <p>Los datos se conservarán mientras dure la relación con el paciente y/o mientras sean necesarios para fines legales o administrativos.</p>

                <h3>7. Cookies y tecnologías similares</h3>
                <p>Nuestro sitio puede utilizar cookies con fines estadísticos y de mejora de la experiencia del usuario.</p>

                <h3>8. Contacto</h3>
                <p>Si tenés dudas sobre esta Política de Privacidad o sobre el uso de tus datos, podés escribirnos a:</p>
                <ul>
                    <li>📧 doconline.ar@gmail.com</li>
                    <li>📞 3425319488</li>
                </ul>
                </div>

            </div>
        </TarjetaPoliticas>

    )
}


const TarjetaPoliticas = styled.div`
    width: 80%;
    height: auto;
    margin: 0  auto;
    background: white;
    border-radius: 12px;
    padding: 50px 50px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    @media only screen and (max-width: 1800px){
        width: 80%;
    }
    @media only screen and (max-width: 1500px){
        width: 44%;
    }
    @media only screen and (max-width: 1350px){
        width: 48%;
    }
    @media only screen and (max-width: 1120px){
        width: 96%;
        height: auto;
    }

    header{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 20%;
        @media only screen and (max-width: 1120px){
            height: auto;
            padding: 1rem 0;
        }
        .tipo{
            text-transform: uppercase;
            font-weight: 500;
            color:  #09c6cf;
            padding: 1rem 0;
        }
        .container-precio{
            display: flex;
            justify-self: center;
            align-items: center;
            padding: 0 auto 1rem auto   ;
            .signo, .precio{
                font-size: 2.2rem;
                font-weight: 400;
            }
            .periodo{
                font-size: 1.2rem;
                font-weight: 300;
                
            }
        }

    }

    .items{
        height: 68%;
        @media only screen and (max-width: 1120px){
            height: auto;
            padding: .6rem 0;
        }

            li{
                list-style: none;
                font-size: 1rem;
                padding: .1rem .6rem;
                display: flex;
                align-items: center;
                margin: .4rem 0;
                @media only screen and (max-width: 1120px){
                    font-size: 1rem;
                }
                svg{
                    color: green;
                    margin-right: 10px;
                    margin-bottom: 3px;
                    width: 20px;
                    min-width:20px;
                }
            }
         
    }

    footer{
        width: 100%;
        padding: 1rem 0;
        height: auto;
        display: flex;
        margin: auto;
        justify-content: center;
        align-items: center;
        @media only screen and (max-width: 1120px){
            height: auto;
            padding: .6rem 0;
        }
        a{
            width: 90%;
        }
        button{
            background: #00b1ff;
            width: 100%;
            padding: 10px 0;
            border: none;
            margin-bottom: 1rem;
            outline: none;
            border-radius: 12px;
            color: white;
            font-weight: bold;
            font-size: 1rem;
            text-transform: uppercase;
            transition: .4s;
            &:hover{
                background: #07aeb6;
            }
        }
    }
`